import React from "react";
import PropTypes from "prop-types";
import HIGRadio from "@hig/radio-button";
import styled from "styled-components";
import { Text } from "@dhxete/text";
const Div = styled.div`
  display: flex;
  > div {
    margin-right: 10px;
    align-items: flex-start;
    position: relative;
    top: 3px;
  }
  margin-bottom: 20px;
`;

const RadioInput = ({
  options
}) => {
  return /*#__PURE__*/React.createElement("form", null, options.map((item, i) => /*#__PURE__*/React.createElement(Div, {
    key: i
  }, /*#__PURE__*/React.createElement(HIGRadio, {
    name: "radio-button"
  }), /*#__PURE__*/React.createElement(Text, null, item))));
};

RadioInput.propTypes = {
  options: PropTypes.array.isRequired
};
export default RadioInput;